import cmp from './BidDetailsDialog'

export default cmp
